import { render, staticRenderFns } from "./BadgeStatus.vue?vue&type=template&id=795096f0&scoped=true"
import script from "./BadgeStatus.vue?vue&type=script&lang=js"
export * from "./BadgeStatus.vue?vue&type=script&lang=js"
import style0 from "./BadgeStatus.vue?vue&type=style&index=0&id=795096f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795096f0",
  null
  
)

export default component.exports